import BORN_IN_THE_CLOUD from "./bornInTheCloudConfig.js";
import LINUX_BURST_RENDER from "./linuxBurstRenderConfig.js";
import ADD_WORKSTATIONS from "./addWorkstationsConfig.js";
import ADD_DATABASES from "./addDatabasesConfig.js";
import ADD_CONTAINERS from "./addContainersConfig.js";
import ADD_NODES from "./addNodesConfig.js";
import ADD_SNOWFLAKES from "./addSnowflakesConfig.js";
import ADD_DISPLAYGATEWAYS from "./addDisplayGatewaysConfig.js";
import ADD_VIRTUALPRIVATENETWORKGATEWAYS from "./addVirtualPrivateNetworkGatewaysConfig.js";

export const CONFIG = {
  DEFAULT: BORN_IN_THE_CLOUD,
  BORN_IN_THE_CLOUD,
  LINUX_BURST_RENDER,
  ADD_WORKSTATIONS,
  ADD_CONTAINERS,
  ADD_DATABASES,
  ADD_NODES,
  ADD_SNOWFLAKES,
  ADD_DISPLAYGATEWAYS,
  ADD_VIRTUALPRIVATENETWORKGATEWAYS
};
